import { ChMedicationType, DeMedicationType } from "@/types/__generated__/union-types"

export const isFreeTextMedicationType = (type: ChMedicationType | DeMedicationType | null): boolean =>
  type === "FREE_TEXT_MEDICATION"
